import TableCell from '@mui/material/TableCell';
import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import { UserResponseViewModel } from 'types/user';

import { UserListCell } from './UserListCell';

interface Props {
    columns: ITableHeadCell[];
    rowData: UserResponseViewModel;
}

export const UserListRow = ({ columns, rowData }: Props) => (
    <>
        {columns.map((item) => (
            <TableCell id={item.id} key={item.field}>
                <UserListCell {...{ item, rowData }} />
            </TableCell>
        ))}
    </>
);
